import { useDeleteTakeWithCleanup } from "../../hooks/DeleteTakeHook";
import Take360 from "../../models/Take360";

export default function useDeleteBubble() {
  const { deleteTakeWithCleanup } = useDeleteTakeWithCleanup();

  const deleteBubble = (take: Take360) => {
    deleteTakeWithCleanup(take);
  };

  return { deleteBubble };
}
